"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return OutlineGetStarted;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function OutlineGetStarted(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        d: "M2 22L7 7L17 17L2 22Z",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M10 5L11 2",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M19 14L22 13",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M17 5C16.6044 5 16.2178 4.8827 15.8889 4.66294C15.56 4.44318 15.3036 4.13082 15.1522 3.76537C15.0009 3.39992 14.9613 2.99778 15.0384 2.60982C15.1156 2.22186 15.3061 1.86549 15.5858 1.58579C15.8655 1.30608 16.2219 1.1156 16.6098 1.03843C16.9978 0.96126 17.3999 1.00087 17.7654 1.15224C18.1308 1.30362 18.4432 1.55996 18.6629 1.88886C18.8827 2.21776 19 2.60444 19 3C19 3.53043 18.7893 4.03914 18.4142 4.41421C18.0391 4.78929 17.5304 5 17 5Z",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M23 3C23 4.5913 22.3679 6.11742 21.2426 7.24264C20.1174 8.36786 18.5913 9 17 9",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M4.76199 13.7141L6.97199 20.3431",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M7.78601 7.78589L11.471 18.8429",
        stroke: "#ffffff",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }));
}

//# sourceMappingURL=OutlineGetStarted.js.map